import MapHelper from "../../utils/helper";
export default class SatelliteViewControl{
    constructor(props){
        this.theme = props.theme;
        this.isSatelliteViewActive = props.isDefaultSattelite;
        this.title = props.title;
    }
    onAdd(map){
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = 'trimblemaps-ctrl trimblemaps-ctrl-group satellite';

        this.controlButton = document.createElement('button');
        this.controlButton.className = 'trimblemaps-ctrl-icon icon-satellite';
        this.controlButton.title="Map/Satellite View";
        this.controlButton.ariaLabel="Map/Satellite View";
        this.controlButton.textContent = '';
        this.controlButton.addEventListener('click', this.handleClick);
        this._container.append(this.controlButton);
        return this._container;
    }

    handleClick = () => {
        if(!this.isSatelliteViewActive){
            this.isSatelliteViewActive = true;
            this._map.setStyle(MapHelper.getMapStyle("satellite"));
        }else{
            this.isSatelliteViewActive =false;
            this._map.setStyle(MapHelper.getMapStyle(this.theme));
        }
    }
    onRemove() {
        if (this.controlButton) {
          this.controlButton.removeEventListener('click', this.handleClick);
        }
        this._container.parentNode.removeChild(this._container);
        this.controlButton = undefined;
        this._map = undefined;
    }
}